export default "__VITE_ASSET__DNcmOFPq__"